export enum SearchType {
    Qualifications = "Qualifications",
    Frameworks = "Frameworks",
    Units = "Units",
    Standards = "Standards",
    TLevels = "TLevels"
}